import script from "./TheSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSearch.vue?vue&type=script&setup=true&lang=js"

import "./TheSearch.vue?vue&type=style&index=0&id=aed2cadc&lang=stylus"

const __exports__ = script;

export default __exports__